import api from "../../../services/api";
import { setCoupon, setCoupons, setEconomicGroupCompanys } from "../../slices/b2b/b2bCoupons.slice";
import { endLoading, initLoading, setError } from "../../slices/generics.slice";
import { logout } from "../user.middleware";

export const getCoupons = (objFilter) => {
  return async (dispatch) => {
    dispatch(initLoading());

    let newFilter = Object.assign({}, objFilter);
    objFilter.pageNumber === "" ? (newFilter.pageNumber = 1) : (newFilter.pageNumber = Number(objFilter.pageNumber));
    objFilter.pageSize === "" ? (newFilter.pageSize = 100) : (newFilter.pageSize = Number(objFilter.pageSize));
    objFilter.key === "" && (newFilter.key = null);
    objFilter.dueDateTo === "" && (newFilter.dueDateTo = null);
    objFilter.dueDateFrom === "" && (newFilter.dueDateFrom = null);
    objFilter.economicGroupId === ""
      ? (newFilter.economicGroupId = null)
      : (newFilter.economicGroupId = Number(objFilter.economicGroupId));
    objFilter.companyId === "" ? (newFilter.companyId = null) : (newFilter.companyId = Number(objFilter.companyId));
    objFilter.active === "" ? (newFilter.active = null) : (newFilter.active = Boolean(Number(objFilter.active)));
    objFilter.plans === "" ? (newFilter.plans = null) : (newFilter.plans = [Number(objFilter.plans)]);

    try {
      const response = await api.post("/coupons/search", newFilter);

      const resp = response?.data?.result?.items;
      dispatch(setCoupons(resp));
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("getCoupons", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

export const getLingoEconomicGroupCompanys = (economicGroupId) => {
  return async (dispatch) => {
    dispatch(initLoading());

    const filterEconomicGroupCompanys = {
      pageNumber: 1,
      pageSize: 999,
      economicGroupId: Number(economicGroupId),
    };

    try {
      const response = await api.post("companies/search", filterEconomicGroupCompanys);

      const resp = response?.data?.result?.items;
      dispatch(setEconomicGroupCompanys(resp));
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("getLingoEconomicGroupCompanys", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

export const deleteCoupon = (couponId) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      await api.delete(`/coupons/coupon/${couponId}`);
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("deleteCoupon", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

export const updateCoupon = (objCouponUpdate) => {
  return async (dispatch) => {
    dispatch(initLoading());

    let newObjCouponUpdate = Object.assign({}, objCouponUpdate);
    objCouponUpdate.percentage === ""
      ? (newObjCouponUpdate.percentage = null)
      : (newObjCouponUpdate.percentage = Number(objCouponUpdate.percentage));
    try {
      const response = await api.put("/coupons", JSON.parse(JSON.stringify(newObjCouponUpdate)));
      dispatch(setCoupon(response.data.result.items[0]));
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("updateCoupon", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

export const addCoupon = (objCouponAdd) => {
  return async (dispatch) => {
    dispatch(initLoading());

    let newObjCouponAdd = Object.assign({}, objCouponAdd);
    objCouponAdd.companyId === ""
      ? (newObjCouponAdd.companyId = null)
      : (newObjCouponAdd.companyId = Number(objCouponAdd.companyId));
    objCouponAdd.plans[0] === 0
      ? (newObjCouponAdd.plans = null)
      : (newObjCouponAdd.plans = objCouponAdd.plans.map((plan) => Number(plan)));
    objCouponAdd.economicGroupId === ""
      ? (newObjCouponAdd.economicGroupId = null)
      : (newObjCouponAdd.economicGroupId = Number(objCouponAdd.economicGroupId));
    objCouponAdd.percentage === ""
      ? (newObjCouponAdd.percentage = null)
      : (newObjCouponAdd.percentage = Number(objCouponAdd.percentage));

    try {
      const response = await api.post("coupons", JSON.parse(JSON.stringify(newObjCouponAdd)));

      const resp = response?.data?.result?.items;
      dispatch(setCoupon(resp[0]));
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("addCoupon", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};
